import { RouterService } from 'app/global/router.service';

export abstract class BaseRedirectGuard {
  constructor(protected _routerService: RouterService) {}

  abstract checkCondition(): Promise<boolean>;
  abstract getRedirectUrl(): string;

  async canActivate(): Promise<boolean> {
    const shouldRedirect = await this.checkCondition();
    if (shouldRedirect) {
      this._routerService.redirectCrmUserToRoute(this.getRedirectUrl());
    }
    return true;
  }
}
